<template>
  <v-container fluid class="test_red">
    <v-row class="pa-1">
      <v-col cols="12" class="content-color px-5 py-2">
        <p class="primary--text text-h6 pa-0 ma-0" v-text="time" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "ExtraTimeOrder",
  props: {
    time: {
      type: String,
      required: true,
    },
  },
};
</script>
<style lang="scss" scoped>
.container {
  border: solid;
  border-color: var(--v-primary-base);
  border-width: 2px;
}
.content-color {
  background-color: rgba($color: #aaa, $alpha: 0.3);
}
p {
  line-height: 0.9rem !important;
}
</style>
